import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CorrespondenceRecipient } from '../../Models/Domains/Account/CorrespondenceRecipient';

declare var IS_RUNNING_IN_APP_POOL;

export class CorrespondenceRecipientClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(headAccountHierarchyId: string): Promise<CorrespondenceRecipient, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/CorrespondenceRecipient/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { headAccountHierarchyId: headAccountHierarchyId }

    return AjaxWrapper.get<CorrespondenceRecipient, any>(url, data);
  }
  public put(recipient: CorrespondenceRecipient): Promise<CorrespondenceRecipient, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/CorrespondenceRecipient/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { recipient: recipient }

    return AjaxWrapper.put<CorrespondenceRecipient, any>(url, data);
  }
}

